// @flow
import React, { type Node, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Tab, { availableTabs as at } from './Tab';
import styles from './ScheduleTable.scss';


type Props = {
  weekDay: string,
  children: ($Values<typeof at>) => Node,
}

const ScheduleTable = ({ weekDay, children }: Props): Node => {
  const { t } = useTranslation('dnevnik');
  const [tab, setTab] = useState(at.TASK);

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th><span className={styles.highlight}>{weekDay}</span></th>
          <th>{t('column_subject_title')}</th>
          <th className={styles.tabs}>
            <Tab
              id={at.TASK}
              active={tab === at.TASK}
              onClick={setTab}
            >
              {t('column_task_title')}
            </Tab>
            <Tab
              id={at.THEME}
              active={tab === at.THEME}
              onClick={setTab}
            >
              {t('column_theme_title')}
            </Tab>
            <Tab
              id={at.BELLS}
              active={tab === at.BELLS}
              onClick={setTab}
            >
              {t('column_bells_title')}
            </Tab>
            <Tab
              id={at.ROOM}
              active={tab === at.ROOM}
              onClick={setTab}
            >
              {t('column_cabinets_title')}
            </Tab>
          </th>
          <th>
            {t('column_marks_title')}
          </th>
        </tr>
      </thead>

      {children(tab)}

    </table>
  );
};

export default ScheduleTable;
